import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import App from './App'
import { registerServiceWorker } from '@/pwa'
import './styles/global.css'

registerServiceWorker()

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root element #root not found')
}

/**
 * Data router is required: features use useBlocker for unsaved-changes guards,
 * which only functions inside createBrowserRouter.
 */
const router = createBrowserRouter([{ path: '*', element: <App /> }])

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
